
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/suport-clienti/retur",
      function () {
        return require("private-next-pages/suport-clienti/retur.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/suport-clienti/retur"])
      });
    }
  